import Text from 'components/Text/Text';
import React from 'react';
import classNames from 'classnames';
import style from './PageBookmarkBtn.module.scss';

interface IPageBookmarkBtn {
	onClick: () => void;
	isActive: boolean;
	btnName: string;
	disabled?: boolean;
	isError?: boolean;
}

const PageBookmarkBtn: React.FC<IPageBookmarkBtn> = ({ onClick, isActive, btnName, disabled, isError }) => {
	const containerClasses = classNames(style.container, { [style.active]: isActive, [style.error]: isError });

	return (
		<>
			{!disabled && (
				<div
					className={containerClasses}
					onClick={disabled ? undefined : () => (isActive ? null : onClick())}
					data-test={btnName}>
					<Text translationNameSpace="form" translationKey={btnName} asFragment={true} />
				</div>
			)}
		</>
	);
};

export default React.memo(PageBookmarkBtn);
